import { Box } from '@mui/material';

// Decoração do painel escuro do login — reescrita pra seguir
// instrucoes_login_siac_css.txt (spec "TELA DE LOGIN SIAC 100% CSS"): grade
// de pontos discreta + 3 formas grandes praticamente imperceptíveis (marca-
// d'água), SEM os circuitos/gráficos abstratos da versão anterior — o novo
// spec pede algo mais restrito, quase invisível, que não compita com o
// texto. 100% CSS/MUI, sem imagem — nítido em qualquer resolução. Só usa
// %/vw/clamp, sem pixel fixo preso a uma resolução específica. Espelha
// exatamente o mesmo arquivo do PDVSIAC.
export const TechDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Grade de pontos — esmaece nas bordas (mask), opacidade geral baixa
        (spec: container opacity .24, ponto rgba(0,226,244,.42) 1px). */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.24,
        backgroundImage: 'radial-gradient(circle, rgba(0, 226, 244, 0.42) 1px, transparent 1.2px)',
        backgroundSize: '36px 36px',
        maskImage: 'linear-gradient(to bottom, transparent 0%, black 12%, black 88%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, black 12%, black 88%, transparent 100%)',
      }}
    />

    {/* Forma 1 — topo-esquerda, maior. */}
    <Box
      sx={{
        position: 'absolute',
        width: 'clamp(240px, 26vw, 360px)',
        height: 'clamp(240px, 26vw, 360px)',
        left: 'clamp(-100px, -9vw, -60px)',
        top: 'clamp(-120px, -10vw, -80px)',
        borderRadius: '80px',
        transform: 'rotate(38deg)',
        background: 'linear-gradient(145deg, rgba(0, 226, 244, 0.08), rgba(0, 226, 244, 0.015))',
      }}
    />

    {/* Forma 2 — inferior-esquerda, com borda bem sutil. */}
    <Box
      sx={{
        position: 'absolute',
        width: 'clamp(220px, 24vw, 330px)',
        height: 'clamp(220px, 24vw, 330px)',
        left: 'clamp(-90px, -8vw, -50px)',
        bottom: 'clamp(24px, 4vh, 40px)',
        borderRadius: '72px',
        transform: 'rotate(45deg)',
        background: 'rgba(0, 226, 244, 0.025)',
        border: '1px solid rgba(0, 226, 244, 0.025)',
      }}
    />

    {/* Forma 3 — centro, opcional (spec item 4), a mais discreta das três. */}
    <Box
      sx={{
        position: 'absolute',
        width: 'clamp(180px, 20vw, 270px)',
        height: 'clamp(180px, 20vw, 270px)',
        left: 'clamp(90px, 12vw, 150px)',
        bottom: 'clamp(120px, 16vh, 190px)',
        borderRadius: '56px',
        transform: 'rotate(42deg)',
        background: 'rgba(0, 226, 244, 0.018)',
      }}
    />
  </Box>
);
